module.exports = __webpack_public_path__ + "static/media/Logo.45ced1f0.png";